import { getAddress, isAddress, isAddressEqual } from "viem";

export const isEqualAddress = (a?: string, b?: string) => {
  if (!a || !b || !isAddress(a) || !isAddress(b)) return false;

  return isAddressEqual(getAddress(a), getAddress(b));
};
